import { Card } from '@ksyos/design-system';
import { styled } from 'styled-components';

export interface IStyledCardProps {
    error?: boolean;
}

export const StyledCard = styled(Card)<IStyledCardProps>`
    border-radius: 3px;
    border: ${(props) => (props.error ? '1px solid #FF9A1E' : 'none')};
    margin: 0 0 4px;
`;
